'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('login', {
    url: '/',
    template: require('./login/login.html'),
    controller: 'LoginController',
    controllerAs: 'vm',
    hideNavbar: true,
    theme: 'homepage',
  })
    .state('settings', {
      url: '/settings',
      template: require('./settings/settings.html'),
      controller: 'SettingsController',
      controllerAs: 'vm',
      theme: 'light'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js